import CallEndIcon from "@mui/icons-material/CallEnd";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";
import PhoneInputGroup from "./phone-number-input-group/phone-input-group.component.tsx";

import Button from "@mui/material/Button";
import { error } from "app/themes/colors";
import TitleBlock from "./title-block.component";
import { useCallback } from "react";

export default function PhoneNumberTab() {
  const { outgoingCall, handleEndCall } = useSunoDialer();

  const id = String(outgoingCall?.id);

  const handleEndCallClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation();
      handleEndCall(id);
    },
    [handleEndCall, id]
  );

  return (
    <>
      <PhoneInputGroup />

      {outgoingCall?.dialInProgress && (
        <>
          <TitleBlock />
          <Button
            variant="contained"
            size="small"
            sx={{
              my: 0.5,
              textTransform: "none",
              background: `${error[700]} !important`,

              "&:hover": {
                background: `${error[800]} !important`,
                color: `white !important`,
                transform: "scale(1.05)",
              },
            }}
            onClick={handleEndCallClick}
          >
            <CallEndIcon sx={{ pr: 1 }} /> End&nbsp;Call
          </Button>
        </>
      )}
    </>
  );
}
